import { routesPath } from '../../common/constants/routesPath';

// The report toolbar's Back. React Router numbers this tab's history entries in `history.state.idx` (a `replace`,
// e.g. after an upgrade, keeps the number), so 0 or no number means the report is the first app page in the tab
// (opened from an email, a pasted link or a new tab): there is nothing to go back to, and Back opens the dashboard.
export const goBack = (navigate, historyState = window.history.state) => {
    if (historyState && historyState.idx > 0) navigate(-1);
    else navigate(routesPath.ROOT.DASHBOARD);
};
